import { FC } from 'react';

import { Spinner } from '@purpur/library';

import { SEARCH_TEST_ID } from '../../test/test-ids';
import { SpinnerWrapper } from './SearchInput.styles';

type Props = { isLoading: boolean; isInputActive: boolean };

export const LoadingSpinner: FC<Props> = ({ isLoading, isInputActive }) =>
    isLoading ? (
        <SpinnerWrapper $isInputActive={isInputActive} data-test={SEARCH_TEST_ID.SEARCH_INPUT_LOADER}>
            <Spinner size="sm" />
        </SpinnerWrapper>
    ) : null;
